export const dateFormatter = (date: Date): string => {
    if (isNaN(date.getTime())) return '';
    return Intl.DateTimeFormat('es', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).format(date);
};

export const formatToDayMonth = (dateStr: string) => {
    const [year, month, day] = dateStr.split('-');
    return `${day}/${month}`;
};
